<template>
  <main class="p-0">
    <div class="item">
      <div class="row">
        <div
          class="col-md-3 mb-4"
          v-for="(item, index) in school_merchant"
          :key="`school_merchant_${index}`"
        >
          <router-link
            :to="`/kewirausahaan/detail-barang/${item.id}`"
            class="card"
          >
            <div
              class="image"
              :style="{
                background: 'url(' + item.image + ')',
              }"
            ></div>

            <div class="content">
              <!-- name brand -->
              <div>
                <div class="brand">
                  <div class="name">
                    {{
                      item.title.length > 50
                        ? item.title.slice(0, 50) + `...`
                        : item.title
                    }}
                  </div>
                </div>

                <div class="title">{{ item.description }}</div>
              </div>
              <!-- rating and count sold -->
              <div class="row">
                <div class="col-6 border-right">
                  <div class="rating d-flex aling-items-center">
                    <img
                      :src="require('@/assets/images/kewirausahaan/rate.png')"
                      alt=""
                    />
                    <p class="ml-2 rating-number">{{ item.rating }}</p>
                  </div>
                </div>
                <div class="col-6">
                  <div class="sold">Terjual {{ item.sold }}</div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-12">
                  <div class=" border-bottom"></div>
                </div>
              </div>
              <!-- name store -->
              <div class="d-flex align-items-center">
                <div class="store-icon mr-2">
                  <img
                    class="img-fluid rounded-circle"
                    :src="item.merchant.logo"
                    alt=""
                  />
                </div>

                <div class="name-store">
                  {{ item.merchant.name }}
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-12">
                  <div class=" border-bottom"></div>
                </div>
              </div>
              <!-- price -->
              <div class="row">
                <div class="col-12">
                  <div class="price">Rp{{ formatNumber(item.price) }}</div>
                </div>
              </div>
              <!-- location -->
              <div class="row  d-flex align-items-center">
                <div class="col-2">
                  <div class="location">
                    <img
                      :src="
                        require('@/assets/images/kewirausahaan/location.png')
                      "
                      alt=""
                    />
                  </div>
                </div>
                <div class="col-10 pl-0">
                  <div class="name-location">
                    {{
                      item.merchant.location != null
                        ? item.merchant.location
                        : "Lokasi belum tersedia"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="row ">
        <div class="col">
          <ul class="page-pagination-orange section-space--top--30">
            <li :class="'btn-disabled'">
              <a @click="goPage('prev')"
                ><i class="fa fa-angle-left"></i> Sebelumnya</a
              >
            </li>

            <li
              v-for="page in paging"
              :key="page"
              :class="[
                currentPage === page || page === '...'
                  ? 'active btn-disabled'
                  : '',
              ]"
            >
              <a @click="getData(page)">{{ page }}</a>
            </li>
            <!--
                            <li class="active"><a href="#">01</a></li>
                            <li><a href="#">02</a></li>
                            <li><a href="#">03</a></li>
                            -->
            <li :class="[currentPage === lastPage ? 'btn-disabled' : '']">
              <a @click="goPage('next')"
                ><i class="fa fa-angle-right"></i> Selanjutnya</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import broker from "../../../../../utils/broker";
import numeral from "numeral";

export default {
  data() {
    return {
      school_merchant: [],
      items: [1, 2, 3, 4, 5, 6, 7, 8],
      title: "TOPI Capten GAMING motif Minecraft warna hijau tosca dan abu abu",
    };
  },
  mounted() {
    this.getDataGoodiesSchool();
  },
  methods: {
    getDataGoodiesSchool() {
      let self = this;
      broker.fetch.get(`/webschool/enterpreneur/goodies`).then((res) => {
        res.data.data.forEach((item) => {
          self.school_merchant.push(item);
        });
      });
    },

    formatNumber(value) {
      let formatted = numeral(value).format("0,0");
      return formatted;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_template_3.scss";
.store-icon {
  width: 16px;
}
</style>
